(() => {
    const elementName = 'yu-home-newsletter';
    if (customElements.get(elementName)) return;

    class YuHomeNewsletter extends HTMLElement {
      connectedCallback() {
        if (this.initialise()) return;
        this.childObserver = new MutationObserver(() => {
          if (this.initialise()) this.childObserver.disconnect();
        });
        this.childObserver.observe(this, { childList: true, subtree: true });
      }

      disconnectedCallback() {
        this.childObserver?.disconnect();
        this.controller?.abort();
        clearTimeout(this.unlockTimer);
        clearTimeout(this.resetTimer);
        if (this.input) this.input.disabled = true;
        if (this.button) this.button.disabled = true;
        this.ready = false;
        this.busy = false;
      }

      initialise() {
        if (this.ready) return true;
        if (this.querySelector('.yu-hps__success')) return true;
        this.form = this.querySelector('.yu-hps__form');
        this.input = this.querySelector('.yu-hps__email');
        this.button = this.querySelector('.yu-hps__join');
        this.error = this.querySelector('.yu-hps__error');
        if (!this.form || !this.input || !this.button || !this.error) return false;

        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        // Register validation before enabling the controls. Invalid input never posts.
        this.button.addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();
          this.attemptSubmit();
        }, options);
        this.input.addEventListener('keydown', event => {
          if (event.key === 'Enter' && !event.isComposing) {
            event.preventDefault();
            event.stopPropagation();
            this.attemptSubmit();
          }
        }, options);
        this.form.addEventListener('submit', event => {
          if (!this.validEmail()) {
            event.preventDefault();
            event.stopImmediatePropagation();
            this.unlock();
            this.showError();
          }
          // Valid requests continue through Shopify's normal form/CAPTCHA handling.
        }, { capture: true, signal: this.controller.signal });
        ['input', 'change'].forEach(type => {
          this.input.addEventListener(type, () => this.clearError(), options);
        });
        this.input.addEventListener('invalid', event => {
          event.preventDefault();
          this.showError();
        }, options);
        this.form.addEventListener('reset', () => {
          clearTimeout(this.resetTimer);
          this.resetTimer = setTimeout(() => {
            if (this.isConnected) { this.unlock(); this.clearError(); }
          }, 0);
        }, options);
        window.addEventListener('pageshow', () => this.unlock(), options);
        this.form.noValidate = true;
        this.ready = true;
        this.busy = false;
        this.input.disabled = false;
        this.button.disabled = false;
        if (this.error.textContent.trim()) this.input.setAttribute('aria-invalid', 'true');
        return true;
      }

      validEmail() {
        const value = this.input.value.trim();
        this.input.value = value;
        return value.length > 0 && this.input.validity.valid && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
      }
      clearError() {
        this.error.textContent = '';
        this.input.removeAttribute('aria-invalid');
      }
      showError() {
        this.error.textContent = this.dataset.invalidMessage || 'Email is invalid.';
        this.input.setAttribute('aria-invalid', 'true');
        this.input.focus({ preventScroll: true });
      }
      attemptSubmit() {
        if (!this.ready || this.busy) return;
        if (!this.validEmail()) { this.showError(); return; }
        this.clearError();
        this.busy = true;
        this.input.readOnly = true;
        this.button.disabled = true;
        this.form.setAttribute('aria-busy', 'true');
        try {
          // Preserve native Shopify customer-form processing, not an AJAX shortcut.
          HTMLFormElement.prototype.requestSubmit.call(this.form);
          this.unlockTimer = setTimeout(() => this.unlock(), 12000);
        } catch (_) {
          this.unlock();
          this.error.textContent = this.dataset.sendError || "We couldn't send your request. Please try again.";
        }
      }
      unlock() {
        clearTimeout(this.unlockTimer);
        this.busy = false;
        if (this.input) this.input.readOnly = false;
        if (this.button && this.isConnected && this.ready) this.button.disabled = false;
        this.form?.removeAttribute('aria-busy');
      }
    }
    customElements.define(elementName, YuHomeNewsletter);
  })();
